export default {
  root: {
  },
  title: {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '34px',
    textAlign: 'center',
    letterSpacing: '0.25px',
    color: '#171721',
  },
  subTitle: {
    fontSize: '24px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  subText: {
    fontSize: '24px',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  optionContainer: {
    width: '100%',
    display: 'flex',
    gap: '80px',
    marginTop: '23px',
    '@media screen and (max-width: 600px)': {
      flexDirection: 'column',
      gap: '12px',
      alignItems: 'stretch',
    },
  },
  button: {
    border: '1px solid rgba(120, 144, 166, 0.5)',
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '8px 22px',
    color: '#7890A6',
    fontWeight: '500',
    fontSize: '15px',
    textTransform: 'uppercase',
    minWidth: '200px',
    height: '56px',
    '@media screen and (max-width: 600px)': {
      minWidth: 0,
      width: '100%',
    },
  },
  backButton: {
    // TODO [UX] use registration default styles
    color: '#7890A6',
  },
  email: {
    color: '#7890A6',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    alignItems: 'flex-start',
    marginTop: '50px',
  },
};
